import { LoginPasswordForm } from "../../organisms/form/LoginPasswordForm";
import { CardTemplate } from "../../templates/CardTemplate";
import { useLoginPassword } from "./hook";

export const LoginPasswordPage: React.FC = () => {
  const { handleLoginPassword, handleForgotPassword, handleBack } =
    useLoginPassword();

  return (
    <CardTemplate title="ログイン">
      <LoginPasswordForm
        handleSubmit={handleLoginPassword}
        handleForgotPassword={handleForgotPassword}
        handleBack={handleBack}
      />
    </CardTemplate>
  );
};
